import { defaultState, WEB_CLIENT } from '@/vuex/webClient/webClientStore';

export default {
  setWebClientSocketConnectionState(state, params) {
    state.webClientSocketConnectionState = params;
  },
  setClientHttpProxiesState(state, params) {
    state.clientHttpProxies = params;
  },
  setProjectList(state, params) {
    state.projectList = params || [];
  },
  setProjectSearch(state, params) {
    state.projectSearch = params || defaultState.projectSearch;
  },
  resetProjectSearch(state) {
    state.projectSearch = defaultState.projectSearch;
  },
  setResourceLoading(state, params) {
    state.resourceLoading = params;
  },
  setRegionList(state, params) {
    state.regionList = params || [];
  },
  setServerList(state, params) {
    state.serverList = params || [];
  },
  addServerConnection(state, params) {
    const connectionList = { ...state.serverConnectionList };
    connectionList[params.resourceKey] = params;
    state.serverConnectionList = { ...connectionList };
  },
  setRDSList(state, params) {
    state.rdsList = params || [];
  },
  addRDSConnection(state, params) {
    const connectionList = { ...state.rdsConnectionList };
    connectionList[params.resourceKey] = params;
    state.rdsConnectionList = { ...connectionList };
  },
  setResourceSearch(state, params) {
    state.resourceSearch = params || defaultState.resourceSearch;
  },
  resetResourceSearch(state) {
    state.resourceSearch = defaultState.resourceSearch;
  },
  setResourceResult(state, params) {
    state.resourceResult = params || defaultState.resourceResult;
  },
  setCurrentProject(state, params) {
    state.currentProject = params;
  },
  setCurrentResourceType(state, params) {
    let result = WEB_CLIENT.RESOURCE_TYPE.SERVER;
    switch (params) {
      case 'EC2':
        result = WEB_CLIENT.RESOURCE_TYPE.SERVER;
        break;
      case 'RDS':
        result = WEB_CLIENT.RESOURCE_TYPE.RDS;
        break;
      case 'DYNAMODB':
        result = WEB_CLIENT.RESOURCE_TYPE.DYNAMODB;
        break;
      case 'S3':
        result = WEB_CLIENT.RESOURCE_TYPE.S3;
        break;
      case 'STORAGE ACCOUNT':
        result = WEB_CLIENT.RESOURCE_TYPE.STORAGEACCOUNT;
        break;
      default:
        result = WEB_CLIENT.RESOURCE_TYPE.SERVER;
        break;
    }
    state.currentResourceType = result;
  },
  setResourceProcessState(state, { resource, processState }) {
    switch (state.currentResourceType) {
      case WEB_CLIENT.RESOURCE_TYPE.SERVER:
        state.serverList = [
          ...state.serverList.map(item => {
            if (item.svr_seq_no === resource.svr_seq_no && item.rmt_port_seq_no === resource.rmt_port_seq_no) {
              item.process_state = processState;
            }
            return item;
          }),
        ];
        break;
      case WEB_CLIENT.RESOURCE_TYPE.RDS:
        state.rdsList = [
          ...state.rdsList.map(item => {
            if (item.db_seq_no === resource.db_seq_no && item.db_port_no === resource.db_port_no) {
              item.process_state = processState;
            }
            return item;
          }),
        ];
        break;
      default:
        break;
    }
  },
  setResourceLocalPort(state, param) {
    switch (state.currentResourceType) {
      case WEB_CLIENT.RESOURCE_TYPE.SERVER:
        state.serverList = [
          ...state.serverList.map(item => {
            if (item.svr_seq_no == param.svr_seq_no && item.rmt_port_seq_no == param.rmt_port_seq_no) {
              item.local_port_no = param.local_port_no;
            }
            return item;
          }),
        ];
        break;
      case WEB_CLIENT.RESOURCE_TYPE.RDS:
        state.rdsList = [
          ...state.rdsList.map(item => {
            if (item.db_seq_no == param.db_seq_no) {
              item.local_port_no = param.local_port_no;
            }
            return item;
          }),
        ];
        break;
      default:
        break;
    }
  },
  setMachine(state, params) {
    state.machineInfo = params;
  },
  setDynamoDBList(state, params) {
    state.dynamoDBList = params || [];
  },
  addDynamoDBConnection(state, params) {
    const connectionList = { ...state.dynamoDBConnectionList };
    connectionList[params.resourceKey] = params;
    state.dynamoDBConnectionList = { ...connectionList };
  },
  setS3List(state, params) {
    state.s3List = params || [];
  },
  addS3Connection(state, params) {
    const connectionList = { ...state.s3ConnectionList };
    connectionList[params.resourceKey] = params;
    state.s3ConnectionList = { ...connectionList };
  },
  setStorageAccountList(state, params) {
    state.storageAccountList = params || [];
  },
  addStorageAccountConn(state, params) {
    state.storageAccountConnList = params;
  },
  setStorageAccountIpList(state, params) {
    state.storageAccountIpList = params || [];
  },
};



// WEBPACK FOOTER //
// ./src/vuex/webClient/webClientMutation.js